module.exports = __webpack_public_path__ + "img/lcbannerzhCn.65e4075c.png";